export const ZIndex = {
  // Pane level z-indices
  // https://leafletjs.com/examples/map-panes/
  connectlvTileLayer: -1,

  shapeGrabHandles: 598,
  networkAnnotations: 597,
  mapControlsNearbyAssets: 593,
  networkTransformers: 590,
  ragTransformers: 590,
  networkConnectionPoints: 570,
  networkNodes: 560,
  networkResults: 550,
  assetDistributedConnection: 540,
  detectAssetCables: 535,
  networkCables: 530,
  ragCables: 520,
  connectlvSiteplanPolygon: 515,
  sitePlan: 510,

  detectAssetMarkers: 999,
  detectAssetInfo: 2000,

  detectNetwork: 600,

  mapControlsPopupResults: 600,

  networkTooltip: 700,

  connectlvSVG: 530,

  // Non-pane level z-indices
  // Need to be compared within the context of their pane if within one
  svgRender: 1999,

  controlDefault: 1000,
} as const;

Object.freeze(ZIndex);
